export const isVersionGreater = (
  currentVersion: string,
  newVersion: string,
) => {
  const v1 = newVersion.split('.').map(Number);
  const v2 = currentVersion.split('.').map(Number);

  for (const [i, num] of v1.entries()) {
    if (num > v2[i]) {
      return true;
    }
    if (num < v2[i]) {
      return false;
    }
  }

  return false;
};
